<template>
  <div id="app" style="min-width: 1200px">
    <PublicHeader @setIsAdmin="setIsAdmin" />
    <div id="appContainer"></div>
    <router-view></router-view>
    <PublicFooter v-if="showFooter" />
    <PublicNotice :isAdmin="isAdmin" />
    <InvitationDialog v-if="inviteModal" :invite-modal="inviteModal" :invite-code="inviteCode" :inviteinfo="inviteinfo" @close="close"></InvitationDialog>
  </div>
</template>

<script>
import qs from 'qs'
import { mapState, mapMutations } from 'vuex'
import actions from '@/actions'
import PublicHeader from './components/header/index.vue'
import PublicFooter from './components/footer/index.vue'
import PublicNotice from './components/notice/index.vue'
import InvitationDialog from '@/components/InvitationDialog'
import { pathOfHome } from '@/utils'
import { fetchInviteInfo } from '@/api/user.js'
import { removeQuery } from '@/utils/common.js'

export default {
  name: 'CentreApp',
  components: { PublicHeader, PublicFooter, PublicNotice, InvitationDialog },
  props: {
    msg: String
  },
  data() {
    return {
      showFooter: false,
      isAdmin: false,

      inviteModal: false,
      inviteCode: '',
      inviteinfo: null,
      locationSearch: ''
    }
  },
  computed: {
    ...mapState(['currentHref']),
    ...mapState('user', ['isLogin'])
  },
  watch: {
    $route: {
      handler(value) {
        if (value && this.checkRouter()) {
          this.setShowFooter(value.path)
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.checkRouter()) {
      this.setShowFooter(this.$store.getters.currentHref)
    }
    // 注册一个观察者函数【 state 是变更后的状态，prevState 是变更前的状态 】
    actions.onGlobalStateChange((state, prevState) => {
      // console.log('主应用观察者，改变前的值', prevState, '改变后的值', state)
      if (prevState.noticeCount !== state.noticeCount) {
        this.$store.commit('user/setNoticeCount', state.noticeCount)
      }
    })

    // 邀请链接
    setTimeout(() => {
      this.handleInviteCode()
    }, 1000)
  },
  methods: {
    // 检查页面路由是否存在，不存在跳转到首页
    checkRouter() {
      const host = location.host
      const name = location.pathname
      const hostname = location.host + name

      let backHome = true
      const hrefArr = ['/user', '/rpaControl', '/em', '/aci', '/afr', '/isf', '/ics', '/vgm', '/ams', '/cps', '/cpsqd', '/freight', '/grab', '/agent', '/track', '/apistore']
      hrefArr.map(h => {
        if (hostname.indexOf(host + h) !== -1) {
          backHome = false
        }
      })

      //
      if (!pathOfHome.includes(name) && backHome) {
        this.$router.push('/')
        return false
      } else {
        return true
      }
    },

    // 设置是否显示页脚
    setShowFooter(path) {
      const hrefArr = ['/user', '/rpaControl', '/em', '/aci', '/afr', '/isf', '/ics', '/vgm', '/ams', '/cps', '/cpsqd', '/freight', '/grab', '/agent', '/track', '/apistore']
      let isSHow = false
      const host = location.host
      const hostname = location.host + location.pathname
      hrefArr.map(h => {
        if (hostname.indexOf(host + h) !== -1) {
          isSHow = true
        }
      })

      if (isSHow) {
        this.showFooter = false
      } else {
        this.showFooter = true
      }

      // hostname.indexOf(host + '/user') !== -1 ||
      // hostname.indexOf(host + '/rpaControl') !== -1 ||
      // hostname.indexOf(host + '/em') !== -1 ||
      // hostname.indexOf(host + '/aci') !== -1 ||
      // hostname.indexOf(host + '/afr') !== -1 ||
      // hostname.indexOf(host + '/isf') !== -1 ||
      // hostname.indexOf(host + '/vgm') !== -1 ||
      // hostname.indexOf(host + '/ams') !== -1 ||
      // hostname.indexOf(host + '/cps') !== -1 ||
      // hostname.indexOf(host + '/cpsqd') !== -1 ||
      // hostname.indexOf(host + '/freight') !== -1 ||
      // hostname.indexOf(host + '/grab') !== -1 ||
      // hostname.indexOf(host + '/agent') !== -1 ||
      // hostname.indexOf(host + '/track') !== -1 ||
      // hostname.indexOf(host + '/apistore') !== -1
    },

    //
    setIsAdmin() {
      this.isAdmin = true
    },

    handleInviteCode() {
      this.checkSessionHasInviteCode(this.checkQueryHasInviteCode())
    },

    // 检查地址中是否有邀请码
    checkQueryHasInviteCode() {
      const href = location.href
      const { inviteCode } = qs.parse(href.split('?')[1])

      if (!inviteCode) return
      // 未登录跳转到登录页
      if (!this.isLogin) {
        sessionStorage.setItem('inviteCode_to_user', inviteCode)
        this.$router.push('/user/register?inviteCode=' + inviteCode)
        return
      }

      return inviteCode
    },

    // 检查sessionStorage是否有邀请码
    async checkSessionHasInviteCode(inviteCode) {
      if (!inviteCode) return
      this.inviteCode = inviteCode
      const resp = await fetchInviteInfo(inviteCode)
      const { code, success, data, msg } = resp

      if (success) {
        this.inviteinfo = data
        this.inviteModal = true
      } else {
        this.$message.warning(code === 6 ? '请先登录，才能使用邀请链接' : msg)
      }
    },

    // 关闭弹窗
    close() {
      removeQuery('inviteCode')
      this.inviteModal = false
    }
  }
}
</script>

<style scoped>
#app {
  height: 100vh;
  position: relative;
}

header {
  height: 60px;
}

header > a {
  margin: 0 20px;
}

.appContainer {
  background: #ccc;
  padding: 20px;
}
</style>
